// import external dependencies
import 'jquery';
import 'owl.carousel';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
    common,
  // Home page
    home,
  // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

// import aos
import AOS from 'aos';
AOS.init();

// import gsap
import { gsap } from 'gsap';

// Load Events
jQuery(document).ready(() => routes.loadEvents());

jQuery(function () {

    jQuery('.owl-carousel').owlCarousel({
        loop: false,
        margin: 0,
        nav: true,
        responsive:{
            0: {
                items: 2,
            },
            500: {
                items: 3,
            },
            600: {
                items: 4,
            },
            700: {
                items: 5,
            },
            800: {
                items: 6,
            },
            1000: {
                items: 7,
            },
            1200: {
                items: 8,
            },
        },
    });

    if (jQuery('.e404-page').length > 0) {
        gsap.set('svg', { visibility: 'visible' });
        gsap.to('#headStripe', {
            y: 0.5,
            rotation: 1,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut',
            duration: 1,
        });
        gsap.to('#spaceman', {
            y: 0.5,
            rotation: 1,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut',
            duration: 1,
        });
        gsap.to('#craterSmall', {
            x: -3,
            yoyo: true,
            repeat: -1,
            duration: 1,
            ease: 'sine.inOut',
        });
        gsap.to('#craterBig', {
            x: 3,
            yoyo: true,
            repeat: -1,
            duration: 1,
            ease: 'sine.inOut',
        });
        gsap.to('#planet', {
            rotation: -2,
            yoyo: true,
            repeat: -1,
            duration: 1,
            ease: 'sine.inOut',
            transformOrigin: '50% 50%',
        });
        gsap.to('#starsBig g', {
            rotation: 'random(-30,30)',
            transformOrigin: '50% 50%',
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut',
        });
        gsap.fromTo(
            '#starsSmall g',
            { scale: 0, transformOrigin: '50% 50%' },
            { scale: 1, transformOrigin: '50% 50%', yoyo: true, repeat: -1, stagger: 0.1 }
        );
        gsap.to('#circlesSmall circle', {
            y: -4,
            yoyo: true,
            duration: 1,
            ease: 'sine.inOut',
            repeat: -1,
        });
        gsap.to('#circlesBig circle', {
            y: -2,
            yoyo: true,
            duration: 1,
            ease: 'sine.inOut',
            repeat: -1,
        });
        gsap.set('#glassShine', { x: -68 });
        gsap.to('#glassShine', {
            x: 80,
            duration: 2,
            rotation: -30,
            ease: 'expo.inOut',
            transformOrigin: '50% 50%',
            repeat: -1,
            repeatDelay: 8,
            delay: 2,
        });

        const mobile = require('is-mobile');
        if (mobile()) jQuery('.video-wrapper').addClass('hidden');

    }

    jQuery(document).on('click', 'a.btn-search, #search-modal a.hamburger', function (e) {
        e.preventDefault();
        jQuery('#search-modal a.hamburger').toggleClass('is-active');
        setTimeout(function () {
            jQuery('#search-modal').toggleClass('visible');
            jQuery('body').toggleClass('scroll-lock');
        }, 100);
    });

    jQuery(document).on('click', 'a.btn-menu, #menu-modal a.hamburger', function (e) {
        e.preventDefault();
        jQuery('#menu-modal a.hamburger, a.btn-menu').toggleClass('is-active');
        setTimeout(function () {
            jQuery('#menu-modal').toggleClass('visible');
            jQuery('body').toggleClass('scroll-lock');
        }, 100);
    });

});



// WEBPACK FOOTER //
// ./scripts/main.js